// src/Services/fetchOrdersByUser.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export async function fetchOrdersByUser(userId) {
    const path = USERS.orderByUser.replace("{userId}", encodeURIComponent(userId));
    const method = "GET";

    // 👇 Dejamos que ApiRequestInterceptor agregue el Authorization usando logindata
    const res = await ApiRequestInterceptor(path, method);

    const code = res?.statusCode ?? res?.code ?? 200;
    let body = res?.data ?? res?.body ?? res;

    if (typeof body === "string") {
        try { body = JSON.parse(body); } catch { }
    }

    if (body && body.data && (Array.isArray(body.data.items) || body.data.count !== undefined)) {
        body = body.data;
    }

    if (code >= 200 && code < 300) {
        const items = Array.isArray(body?.items) ? body.items : [];
        const count = Number.isFinite(body?.count) ? body.count : items.length;
        return { items, count };
    }

    throw new Error(body?.message || `Error al obtener pedidos del usuario (code ${code})`);
}